import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { CartEffects } from '@signature-it/ngx-catalogue/store/effects';
import { CartService } from '@signature-it/ngx-catalogue/services';

@NgModule({
    imports: [
        EffectsModule.forFeature([CartEffects])
    ],
    providers: [
        CartService
    ]
})
export class CartStoreModule { }
